import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { Sort } from '@angular/material/sort';
import { GlobalService } from 'src/app/global.service';
import { UserDetailsComponent } from '../user-details/user-details.component';

@Component({
  selector: 'app-user-list-table',
  templateUrl: './user-list-table.component.html',
  styleUrls: ['./user-list-table.component.css']
})
export class UserListTableComponent {

  @ViewChild(UserDetailsComponent) 
  private UserDetailsModal!:UserDetailsComponent;

  @Input() isLoading : boolean = false;
  @Input() message : String = "";
  @Input() userList : Array<any> = [];
  @Output() updateSort = new EventEmitter<Sort>();
  @Output() onItemClickEmitter = new EventEmitter<Sort>();
  
  isMobile : boolean = false;

  constructor(
    public globalservice : GlobalService
  ){}

  ngOnInit(){
    this.isMobile = this.globalservice.isMobile();
  }

  onItemClick(data:any){
    this.onItemClickEmitter.emit(data);
  }
  openDetails(data:any, event:Event){
    this.UserDetailsModal.openModal();
    this.UserDetailsModal.getUserDetails(data);
    event.stopPropagation();
  }
  sortData(sort:Sort){
    this.updateSort.emit(sort);
  }

}
